import { __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Caption.st.css.js';
import Ellipsis, { extractEllipsisProps } from '../common/Ellipsis';
import { EllipsisCommonProps } from '../common/PropTypes/EllipsisCommon';
const CaptionWithEllipsis = (_a) => {
    var { dataHook, className, tagName, caption, light, children } = _a, props = __rest(_a, ["dataHook", "className", "tagName", "caption", "light", "children"]);
    const { ellipsisProps, componentProps } = extractEllipsisProps(props);
    return (React.createElement(Ellipsis, Object.assign({}, ellipsisProps, { wrapperClassName: classes[caption], render: ({ ref, ellipsisClasses }) => {
            return React.createElement(tagName, Object.assign({ ref, className: st(classes.root, { caption }, ellipsisClasses(className)), 'data-hook': dataHook, 'data-light': light }, componentProps), children);
        } })));
};
CaptionWithEllipsis.displayName = 'Caption';
CaptionWithEllipsis.propTypes = Object.assign({ 
    /** Applied as data-hook HTML attribute that can be used in the tests */
    dataHook: PropTypes.string, 
    /** class to be applied to the root element */
    className: PropTypes.string, 
    /** tag name that will be rendered */
    tagName: PropTypes.string, caption: PropTypes.oneOf(['c1', 'c2']), 
    /** make the text color lighter */
    light: PropTypes.bool }, EllipsisCommonProps);
CaptionWithEllipsis.defaultProps = Object.assign({ caption: 'c1', tagName: 'span' }, Ellipsis.defaultProps);
export default CaptionWithEllipsis;
//# sourceMappingURL=Caption.js.map